import { $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'
import { DrawerMenu } from './drawer-menu'

const DRAWER_MENU_SELECTOR = 'drawer-menu'

export class DrawerMenuPageLink extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handlePageLinkClick)
    this.addListener(this, 'keyup', this.handleKeyDown)
  }

  handlePageLinkClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.setPage()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.setPage()
    }
  }

  setPage(): void {
    const drawerMenu: DrawerMenu = $elParent(DRAWER_MENU_SELECTOR, this)
    if (drawerMenu) {
      drawerMenu.setPage(drawerMenu.pageMap[this.dataset.pageId])
      drawerMenu.setAttribute('data-menu-id', this.dataset.pageId)
    }
  }
}
